import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { baseTheme } from '../../../theme';

import { updatePostListConfig, getPostsAction } from '../../../store';
import { getTagsListAction, getGroupsListAction } from '../../../store/posts/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: 'flex-end',
    },
    leftActions: {
      marginTop: theme.spacing(2),
    },
    formControlContainers: {
      marginRight: theme.spacing(2),
    },
    formControls: {
      width: '100%',
    },
  }),
);

export default function PostSearchControls(props: any) {
  const classes = useStyles(baseTheme);
  const sizeAdjust = props.editEnabled ? 12 : 4;
  const searchFieldSize = props.editEnabled ? 3 : 4;
  const dispatch = useDispatch();
  const currUser = useSelector((state: any) => state.auth.currUser);
  const searchConfig = useSelector((state: any) => state.posts.listConfig);
  const tags = useSelector((state: any) => state.posts.tags);
  const groups = useSelector((state: any) => state.posts.groups);
  const state = useSelector((state: any) => state);

  useEffect(() => {
    if (currUser && searchConfig) {
      getPostsAction(currUser.uid, searchConfig, dispatch);
      getTagsListAction(currUser.uid, dispatch);
      getGroupsListAction(currUser.uid, dispatch);
    }
  }, [currUser, searchConfig, dispatch]);

  const handleFormChange = (prop: any) => (event: any) => {
    const updatedValues = {
      ...searchConfig,
      [prop]: event.target.value,
    };

    updatePostListConfig(updatedValues, dispatch);
  };

  const renderFilterTagsOptions = () => {
    const filterTagOptions = [
      <MenuItem value="all">All Tags</MenuItem>,
    ];
    tags?.forEach((tag: any) => {
      filterTagOptions.push(<MenuItem value={tag}>{tag}</MenuItem>);
    });
    return filterTagOptions;
  };

  const renderFilterGroupOptions = () => {
    const filterGroupOptions = [
      <MenuItem value="all">All Groups</MenuItem>,
    ];
    if (!groups || groups.length === 0) {
      return filterGroupOptions;
    }
    groups?.forEach((group: any) => {
      filterGroupOptions.push(<MenuItem value={group.id}>{group.name}</MenuItem>);
    });
    return filterGroupOptions;
  };

  return (
    <>
      <Grid item container xs={12} md={sizeAdjust} className={classes.leftActions}>
        <Grid item xs={12} className={classes.formControlContainers}>
          <FormControl className={classes.formControls}>
            <TextField
              label="Search"
              value={searchConfig.search}
              variant="outlined"
              onChange={handleFormChange('search')}
              InputProps={{
                endAdornment:
                  (<InputAdornment position="end">
                    <IconButton
                      aria-label="search posts"
                      edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>),
              }}
              size="small" />
          </FormControl>
        </Grid>
      </Grid>
      <Grid item container xs={12} md={sizeAdjust} className={classes.leftActions}>
        <Grid item xs={2} className={classes.formControlContainers}>
          <FormControl variant="outlined" className={classes.formControls} size="small">
            <InputLabel id="filter-posts">Filter</InputLabel>
            <Select
              labelId="filter-posts"
              id="filter-posts"
              value={searchConfig.filter}
              label="Filter"
              onChange={handleFormChange('filter')}
            >
              <MenuItem value="all">All Posts</MenuItem>
              <MenuItem value="private">Private Posts</MenuItem>
              <MenuItem value="public">Public Group Posts</MenuItem>
              <MenuItem value="closed">Closed Group Posts</MenuItem>
              <MenuItem value="posted">Live</MenuItem>
              <MenuItem value="not-posted">Not Live</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} className={classes.formControlContainers}>
          <FormControl variant="outlined" className={classes.formControls} size="small">
            <InputLabel id="filter-group">Group</InputLabel>
            <Select
              labelId="filter-group"
              id="filter-group"
              value={searchConfig.groups}
              label="Group"
              onChange={handleFormChange('groups')}
              >
              {renderFilterGroupOptions()}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={2} className={classes.formControlContainers}>
          <FormControl variant="outlined" className={classes.formControls} size="small">
              <InputLabel id="filter-tags">Tags</InputLabel>
              <Select
                labelId="filter-tags"
                id="filter-tags"
                value={searchConfig.tags}
                label="Tags"
                onChange={handleFormChange('tags')}
              >
                  {renderFilterTagsOptions()}
              </Select>
          </FormControl>
        </Grid>

        <Grid item xs={2} className={classes.formControlContainers}>
          <FormControl variant="outlined" className={classes.formControls} size="small">
            <InputLabel id="sort-posts">Sort</InputLabel>
            <Select
              labelId="sort-posts"
              id="sort-posts"
              value={searchConfig.sort}
              label="Sort"
              onChange={handleFormChange('sort')}
            >
              <MenuItem value="date-ascend">Date Ascending</MenuItem>
              <MenuItem value="date-descend">Date Descending</MenuItem>
              <MenuItem value="title-ascend">Post Title Asending</MenuItem>
              <MenuItem value="title-descend">Post Title Descending</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}
